import { AnalyticsIcon } from "../../Resources/Icons/icons";
import DashboardIcon from "../../Resources/MainIcons/Dashboard.png";
import ConfirmationNumberIcon from "../../Resources/MainIcons/Master.png";
import AccountBoxIcon from "../../Resources/MainIcons/User.png";
import AddBusinessIcon from "../../Resources/MainIcons/CompanyLogin.png";
import PolicyIcon from "../../Resources/MainIcons/Policy.png";
import ManageAccountsIcon from "../../Resources/MainIcons/Utilities.png";
import SummarizeIcon from "../../Resources/MainIcons/Report.png";
import EventRepeatIcon from "../../Resources/MainIcons/Renewal.png";
import AccountBalanceWalletIcon from "../../Resources/MainIcons/Wallet.png";
import MopedIcon from "../../Resources/MainIcons/Calculator.png";
import "./Menu.css";
import { ROADZEN_CERT_LIST_PATH, ROADZEN_COMPANY_WALLET_PATH, ROADZEN_CREATE_CERT_PATH, ROADZEN_USERS_PATH, ROADZEN_WALLET_PATH } from "../Roadzen/roadzenPaths";
import {
  isBriskV2Enabled,
  BRISK_V2_LIST_PATH,
  BRISK_V2_WALLET_PATH,
  BRISK_V2_HISTORY_PATH,
  BRISK_V2_REPORT_PATH,
} from "../../Shared/briskV2Flag";

// Brisk certificates (new, "V2"): the "Brisk Certificate List" item, only while REACT_APP_BRISK_V2_ENABLED is "true"
// (off = the menus exactly as before).
const briskV2ListItem = (child) =>
  isBriskV2Enabled()
    ? [{ title: "Brisk Certificate List", path: BRISK_V2_LIST_PATH, child, icon: <AnalyticsIcon />, subMenu: [] }]
    : [];

// Brisk money pages (owner, 2026-10-30): the agency's Brisk wallet, how money was put in, and every movement. Admin menu
// only (the admin and the super admin log in with it); same switch as above.
const briskV2MoneyItems = (child) =>
  isBriskV2Enabled()
    ? [
        { title: "Brisk Wallet", path: BRISK_V2_WALLET_PATH, child, icon: <AnalyticsIcon />, subMenu: [] },
        { title: "Transaction History", path: BRISK_V2_HISTORY_PATH, child, icon: <AnalyticsIcon />, subMenu: [] },
        { title: "Transaction Report", path: BRISK_V2_REPORT_PATH, child, icon: <AnalyticsIcon />, subMenu: [] },
      ]
    : [];

// RoadZen certificates in every non-admin menu (owner: "create page want to show for all users"); Users / Wallet are admin only
const roadzenListItem = (child) => ({ title: "Zen Certificate List", path: ROADZEN_CERT_LIST_PATH, child, icon: <AnalyticsIcon />, subMenu: [] });
const roadzenCertItems = (child) => [
  { title: "Zen CPA/RSA", path: ROADZEN_CREATE_CERT_PATH, child, icon: <AnalyticsIcon />, subMenu: [] },
  roadzenListItem(child),
];

//Admin Menu ---- usertype = client
const AdminMenu = [
  {
    parent: 1,
    title: "Dashboard",
    path: "/dashboard",
    icon: (
      <img
        src={DashboardIcon}
        alt="DashboardIcon"
        style={{ width: "19px", height: "18px" }}
      />
    ),
    subMenu: [],
  },
  {
    parent: 2,
    title: "Master",
    path: "/master",
    icon: (
      <img
        src={ConfirmationNumberIcon}
        alt="ConfirmationNumberIcon"
        style={{ width: "19px", height: "18px" }}
      />
    ),
    subMenu: [
      {
        title: "Insurance Company",
        path: "/company",
        child: 2,
        icon: <AnalyticsIcon />,
        subMenu: [],
      },
      {
        title: "Our Company",
        path: "/masterCompany",
        child: 2,
        icon: <AnalyticsIcon />,
        subMenu: [],
      },
      {
        title: "Booking Code",
        path: "/#",
        child: 2,
        subOrder: 106,
        icon: <AnalyticsIcon />,
        subMenu: [
          {
            title: "Booking Code",
            path: "/bookingcode",
            subChild: 106,
            icon: <AnalyticsIcon />,
            subMenu: [],
          },
          {
            title: "Sub Booking Code",
            path: "/subBookingCode",
            subChild: 106,
            icon: <AnalyticsIcon />,
            subMenu: [],
          },
        ],
      },
      {
        title: "Link Booking Code",
        path: "/linkbookingcode",
        child: 2,
        icon: <AnalyticsIcon />,
        subMenu: [],
      },
      {
        title: "Link Supplier",
        path: "/linksupplier",
        child: 2,
        icon: <AnalyticsIcon />,
        subMenu: [],
      },
      {
        title: "Policy Period",
        path: "/policyperiod",
        child: 2,
        icon: <AnalyticsIcon />,
        subMenu: [],
      },
      {
        title: "Policy Type",
        path: "/policytype",
        child: 2,
        icon: <AnalyticsIcon />,
        subMenu: [],
      },
      {
        title: "Product",
        path: "/#",
        child: 2,
        icon: <AnalyticsIcon />,
        subOrder: 105,
        subMenu: [
          {
            title: "Product",
            path: "/product",
            subChild: 105,
            icon: <AnalyticsIcon />,
            subMenu: [],
          },
          {
            title: "Sub Product",
            path: "/subProduct",
            subChild: 105,
            icon: <AnalyticsIcon />,
            subMenu: [],
          },
        ],
      },
      {
        title: "Fuel Type",
        path: "/fuelType",
        child: 2,
        icon: <AnalyticsIcon />,
        subMenu: [],
      },
      {
        title: "Link RTO Code",
        path: "/rtoMapping",
        child: 2,
        icon: <AnalyticsIcon />,
        subMenu: [],
      },
      {
        title: "Online Policy Master",
        path: "/#",
        child: 2,
        subOrder: 107,
        icon: <AnalyticsIcon />,
        subMenu: [
          {
            title: "Make and Model",
            path: "/makeModel",
            subChild: 107,
            icon: <AnalyticsIcon />,
            subMenu: [],
          },
          {
            title: "Combined Make and Model",
            path: "/makeModelCombo",
            subChild: 107,
            icon: <AnalyticsIcon />,
            clientOnly: true,
            subMenu: [],
          },
          {
            title: "Financier",
            path: "/financier",
            subChild: 107,
            icon: <AnalyticsIcon />,
            subMenu: [],
          },
          {
            title: "RTO City Location",
            path: "/rtoCityLocation",
            subChild: 107,
            icon: <AnalyticsIcon />,
            subMenu: [],
          },
          // {
          //   title: "Nil Dip",
          //   path: "/nilDip",
          //   subChild: 107,
          //   icon: <AnalyticsIcon />,
          //   subMenu: [],
          // },
        ],
      },
      {
        title: "Vehicle Make",
        path: "/vehicleMake",
        child: 2,
        icon: <AnalyticsIcon />,
        subMenu: [],
      },
      {
        title: "Add On",
        path: "/addon",
        child: 2,
        icon: <AnalyticsIcon />,
        subMenu: [],
      },
      {
        title: "Change Log",
        path: "/masterChangeLog",
        child: 2,
        icon: <AnalyticsIcon />,
        subMenu: [],
      },
    ],
  },
  {
    parent: 3,
    title: "User",
    path: "/users",
    icon: (
      <img
        src={AccountBoxIcon}
        alt="AccountBoxIcon"
        style={{ width: "15px", height: "18px" }}
      />
    ),
    subMenu: [
      {
        title: "User",
        path: "/user",
        child: 3,
        icon: <AnalyticsIcon />,
        subMenu: [],
      },
      {
        title: "Client",
        path: "/client",
        child: 3,
        // Only the SUPER_ADMIN manages clients; see menuForUser.
        superAdminOnly: true,
        icon: <AnalyticsIcon />,
        subMenu: [],
      },
      {
        title: "Branch",
        path: "/branch",
        icon: <AnalyticsIcon />,
        child: 3,
        subMenu: [],
      },
      {
        title: "Configuration",
        path: "/#",
        child: 3,
        subOrder: 101,
        // User / Branch / Receivable Config: the SUPER_ADMIN only (owner, 2026-10-21); see menuForUser.
        superAdminOnly: true,
        icon: <AnalyticsIcon />,
        subMenu: [
          {
            title: "User Config",
            path: "/userConfiguration",
            subChild: 101,
            icon: <AnalyticsIcon />,
            subMenu: [],
          },
          {
            title: "Branch Config",
            path: "/branchConfiguration",
            subChild: 101,
            icon: <AnalyticsIcon />,
            subMenu: [],
          },
          {
            title: "Receivable Config",
            path: "/receivableConfiguration",
            subChild: 101,
            icon: <AnalyticsIcon />,
            subMenu: [],
          },
        ],
      },
      // Added by Arun
      {
        title: "Common Configuration",
        path: "/commonConfiguration",
        icon: <AnalyticsIcon />,
        child: 3,
        subMenu: [],
      },
    ],
  },
  {
    parent: 4,
    title: "Access",
    path: "/companyLogin",
    icon: (
      <div className="menu-item">
        <img
          src={AddBusinessIcon}
          alt="AddBusinessIcon"
          style={{ width: "19px", height: "18px" }}
        />
      </div>
    ),
    subMenu: [],
  },
  {
    parent: 5,
    title: "Brisk CPA / RSA",
    path: "/policy",
    icon: (
      <img
        src={PolicyIcon}
        alt="PolicyIcon"
        style={{ width: "15px", height: "18px" }}
      />
    ),
    subMenu: [
      // Moved here from the Policy dropdown (owner, 2026-10-27): Create Certificate, Brisk Certificate List. The CPA List
      // page was removed (owner, 2026-10-30).
      {
        title: "Create Certificate",
        path: "/briskCreateCertificate",
        child: 5,
        icon: <AnalyticsIcon />,
        subMenu: [],
      },
      ...briskV2ListItem(5),
      ...briskV2MoneyItems(5),
      // The earlier items of this dropdown, kept commented (owner, 2026-10-27).
      // {
      //   title: "Create Certificate",
      //   path: "/briskCreateCertificates",
      //   child: 5,
      //   icon: <AnalyticsIcon />,
      // },
      // {
      //   title: "Certificate List",
      //   path: "/briskDownloadCertificate",
      //   child: 5,
      //   icon: <AnalyticsIcon />,
      //   subMenu: [],
      // },
      // {
      //   title: "Wallet Transaction History",
      //   path: "/briskTransactionHistorys",
      //   child: 5,
      //   icon: <AnalyticsIcon />,
      //   subMenu: [],
      // },
      // {
      //   title: "Wallet Report",
      //   path: "/briskWallets",
      //   child: 5,
      //   icon: <AnalyticsIcon />,
      //   subMenu: [],
      // },
    ],
  },
  // RoadZen (owner, 2026-11-03): a CPA / RSA provider like Brisk. Users = RoadZen's sellers. CLIENT logins only (the
  // super admin changes them, agency admins only see them); the accountant and every other login never get it.
  // {
  //   parent: 13,
  //   title: "Zen CPA/RSA",
  //   path: "/roadzen",
  //   icon: (
  //     <img
  //       src={PolicyIcon}
  //       alt="PolicyIcon"
  //       style={{ width: "15px", height: "18px" }}
  //     />
  //   ),
  //   subMenu: [
  //     // certificates like Brisk (2026-11-03): the accountant sees the list but does not create
  //     {
  //       title: "Create Certificate",
  //       path: ROADZEN_CREATE_CERT_PATH,
  //       child: 13,
  //       clientOnly: true,
  //       icon: <AnalyticsIcon />,
  //       subMenu: [],
  //     },
  //     {
  //       title: "Certificate List",
  //       path: ROADZEN_CERT_LIST_PATH,
  //       child: 13,
  //       icon: <AnalyticsIcon />,
  //       subMenu: [],
  //     },
  //     // the agency's Company Wallet "RoadZen", like the Brisk Wallet (owner, 2026-11-03)
  //     {
  //       title: "Zen Wallet",
  //       path: ROADZEN_COMPANY_WALLET_PATH,
  //       child: 13,
  //       clientOnly: true,
  //       icon: <AnalyticsIcon />,
  //       subMenu: [],
  //     },
  //     {
  //       title: "Users",
  //       path: ROADZEN_USERS_PATH,
  //       child: 13,
  //       clientOnly: true,
  //       icon: <AnalyticsIcon />,  
  //       subMenu: [],
  //     },
  //     // RoadZen's wallet of one user: statement, payment links, Add Amount (active user only) — owner, 2026-11-03
  //     {
  //       title: "Wallet",
  //       path: ROADZEN_WALLET_PATH,
  //       child: 13,
  //       clientOnly: true,
  //       icon: <AnalyticsIcon />,
  //       subMenu: [],
  //     },
  //   ],
  // },
  {
    parent: 6,
    title: "Policy",
    path: "/policy",
    icon: (
      <img
        src={PolicyIcon}
        alt="PolicyIcon"
        style={{ width: "15px", height: "18px" }}
      />
    ),
    subMenu: [
      // Create Certificate and Brisk Certificate List moved to the "Brisk CPA / RSA" dropdown (owner, 2026-10-27).
      // {
      //   title: "Create Certificate",
      //   path: "/briskCreateCertificate",
      //   child: 6,
      //   icon: <AnalyticsIcon />,
      //   subMenu: [],
      // },
      {
        title: "Search Policy",
        path: "/searchPolicy",
        child: 6,
        icon: <AnalyticsIcon />,
        subMenu: [],
      },
      // ...briskV2ListItem(6),
      {
        title: "Policy List",
        path: "/policyList",
        child: 6,
        icon: <AnalyticsIcon />,
        subMenu: [],
      },
      {
        title: "Online Policy",
        path: "/onlinePolicy",
        child: 6,
        icon: <AnalyticsIcon />,
        subMenu: [],
      },
    ],
  },
  {
    parent: 7,
    title: "Utilites",
    path: "/utilies",
    icon: (
      <img
        src={ManageAccountsIcon}
        alt="ManageAccountsIcon"
        style={{ width: "19px", height: "18px" }}
      />
    ),
    subMenu: [
      {
        title: "User Payable",
        path: "/userPayable",
        child: 7,
        icon: <AnalyticsIcon />,
        subMenu: [],
      },
      {
        title: "Branch Payable",
        path: "/branchPayable",
        child: 7,
        icon: <AnalyticsIcon />,
        subMenu: [],
      },
      {
        title: "Comission Receivable",
        path: "/commisionReceivale",
        child: 7,
        icon: <AnalyticsIcon />,
        subMenu: [],
      },
      {
        title: "Receivable Status",
        path: "/receivaleStatus",
        child: 7,
        icon: <AnalyticsIcon />,
        subMenu: [],
      },
      {
        title: "Cheque Status",
        path: "/chequeStatus",
        child: 7,
        icon: <AnalyticsIcon />,
        subMenu: [],
      },
      {
        title: "Log Status",
        path: "/logStatus",
        child: 7,
        icon: <AnalyticsIcon />,
        subMenu: [],
      },
      {
        title: "Rayalchat users info",
        path: "/rayalchat-users-info",
        child: 7,
        icon: <AnalyticsIcon />,
        subMenu: [],
      },
      {
        title: "User Additional",
        path: "/receivableBulkUpload",
        child: 7,
        icon: <AnalyticsIcon />,
        subMenu: [],
      },

      // {
      //   title: "Office Expenses",
      //   path: "/officeExpenses",
      //   child: 6,
      //   icon: <AnalyticsIcon />,
      //   subMenu: [],
      // },
    ],
  },
  {
    parent: 8,
    title: "Report",
    path: "/product",
    icon: (
      <img
        src={SummarizeIcon}
        alt="SummarizeIcon"
        style={{ width: "19px", height: "18px" }}
      />
    ),
    subMenu: [
      {
        title: "Master Report",
        path: "/masterReport",
        child: 8,
        icon: <AnalyticsIcon />,
        subMenu: [],
      },
      {
        title: "Cheque Report",
        path: "/policyChequeReport",
        child: 8,
        icon: <AnalyticsIcon />,
        subMenu: [],
      },
      {
        title: "Booking Report",
        path: "/bookingReport",
        child: 8,
        icon: <AnalyticsIcon />,
        subMenu: [],
      },
      {
        title: "Motor Report",
        path: "/MotorReport",
        child: 8,
        icon: <AnalyticsIcon />,
        subMenu: [],
      },
    ],
  },
  // {
  //   parent: 9,
  //   title: "Renewal",
  //   path: "/renewalPolicy",
  //   icon: (
  //     <img
  //       src={EventRepeatIcon}
  //       alt="EventRepeatIcon"
  //       style={{ width: "17px", height: "19px" }}
  //     />
  //   ),
  //   subMenu: [],
  // },
  // {
  //   parent: 10,
  //   title: "Wallet",
  //   path: "/wallet",
  //   icon: (
  //     <div className="menu-item">
  //       <img
  //         src={AccountBalanceWalletIcon}
  //         alt="AccountBalanceWalletIcon"
  //         style={{ width: "16px", height: "18px" }}
  //       />
  //     </div>
  //   ),
  //   subMenu: [
  //     {
  //       title: "User Wallet",
  //       path: "/userWallet",
  //       child: 10,
  //       icon: <AnalyticsIcon />,
  //       subMenu: [],
  //     },
  //     {
  //       title: "Motor Wallet",
  //       path: "/motorWallet",
  //       child: 10,
  //       icon: <AnalyticsIcon />,
  //       subMenu: [],
  //     },
  //     {
  //       title: "Branch Wallet",
  //       path: "/branchWallet",
  //       child: 10,
  //       icon: <AnalyticsIcon />,
  //       subMenu: [],
  //     },
  //     {
  //       title: "Company Wallet",
  //       path: "/companyWallet",
  //       child: 10,
  //       icon: <AnalyticsIcon />,
  //       subMenu: [],
  //     },
  //     {
  //       title: "Payment Paid / Received",
  //       path: "/paymentPaidAndReceived",
  //       child: 10,
  //       icon: <AnalyticsIcon />,
  //       subMenu: [],
  //     },
  //     {
  //       title: "TDS Report",
  //       path: "/tdsReport",
  //       child: 10,
  //       icon: <AnalyticsIcon />,
  //       subMenu: [],
  //     },
  //     {
  //       title: "Brisk Wallet",
  //       path: "/briskWallet",
  //       child: 10,
  //       icon: <AnalyticsIcon />,
  //       subMenu: [],
  //     },
  //     // {
  //     //   title: "Brisk Transaction History",
  //     //   path: "/briskTransactionHistory",
  //     //   child: 9,
  //     //   icon: <AnalyticsIcon />,
  //     //   subMenu: [],
  //     // },
  //   ],
  // },
  {
    parent: 12,
    title: "Wallet",
    path: "/wallet",
    icon: (
      <div className="menu-item">
        <img
          src={AccountBalanceWalletIcon}
          alt="AccountBalanceWalletIcon"
          style={{ width: "16px", height: "18px" }}
        />
      </div>
    ),
    subMenu: [
      {
        title: "User Wallet",
        path: "/userWallet",
        child: 12,
        icon: <AnalyticsIcon />,
        subMenu: [],
      },
      {
        title: "Company Wallet",
        path: "/clientCompanyWallet",
        child: 12,
        icon: <AnalyticsIcon />,
        subMenu: [],
      },
      {
        title: "Policy Wallet",
        path: "/adminPolicyWallet",
        child: 12,
        icon: <AnalyticsIcon />,
        subMenu: [],
      },
      // {
      //   title: "Payment Paid / Received",
      //   path: "/paymentPaidAndReceived",
      //   child: 12,
      //   icon: <AnalyticsIcon />,
      //   subMenu: [],
      // },
      // {
      //   title: "TDS Report",
      //   path: "/tdsReport",
      //   child: 12,
      //   icon: <AnalyticsIcon />,
      //   subMenu: [],
      // },
    ],
  },
  {
    parent: 11,
    title: "Motor Calculation",
    path: "/motorCalculation",
    icon: (
      <img
        src={MopedIcon}
        alt="MopedIcon"
        style={{ width: "15px", height: "18px" }}
      />
    ),
    subMenu: [],
  },
];

//Branch Manager Menu
const BranchManagerMenu = [
  {
    parent: 1,
    title: "Dashboard",
    path: "/dashboard",
    icon: (
      <img
        src={DashboardIcon}
        alt="DashboardIcon"
        style={{ width: "19px", height: "18px" }}
      />
    ),
    subMenu: [],
  },
  {
    // Master dropdown for non-admin roles. The page itself is role-aware:
    // these users see ONLY the make/models assigned to them and may edit only
    // their own discount — see MakeModel.js.
    parent: 20,
    title: "Master",
    path: "/master",
    icon: (
      <img
        src={ConfirmationNumberIcon}
        alt="ConfirmationNumberIcon"
        style={{ width: "19px", height: "18px" }}
      />
    ),
    subMenu: [
      {
        title: "Make and Model",
        path: "/makeModel",
        child: 20,
        icon: <AnalyticsIcon />,
        subMenu: [],
      },
      {
        // Same role split: assigned rows only, and anything added here is
        // linked to this user automatically — see RTOCityLocation.js.
        title: "RTO City Location",
        path: "/rtoCityLocation",
        child: 20,
        icon: <AnalyticsIcon />,
        subMenu: [],
      },
    ],
  },
  {
    parent: 3,
    title: "User",
    path: "/users",
    icon: (
      <img
        src={AccountBoxIcon}
        alt="AccountBoxIcon"
        style={{ width: "15px", height: "18px" }}
      />
    ),
    subMenu: [
      {
        title: "User",
        path: "/user",
        child: 3,
        icon: <AnalyticsIcon />,
        subMenu: [],
      },
      {
        title: "User Config",
        path: "/userConfiguration",
        icon: <AnalyticsIcon />,
        child: 3,
        subMenu: [],
      },
    ],
  },
  {
    parent: 4,
    title: "Company Login",
    path: "/companyLogin",
    icon: (
      <div className="menu-item">
        <img
          src={AddBusinessIcon}
          alt="AddBusinessIcon"
          style={{ width: "19px", height: "18px" }}
        />
      </div>
    ),
    subMenu: [],
  },
  {
    parent: 5,
    title: "Policy",
    path: "/policy",
    icon: (
      <img
        src={PolicyIcon}
        alt="PolicyIcon"
        style={{ width: "15px", height: "18px" }}
      />
    ),
    subMenu: [
      // {
      //   title: "Create Policy",
      //   path: "/policycreate",
      //   child: 5,
      //   icon: <AnalyticsIcon />,
      // },
      {
        title: "Search Policy",
        path: "/searchPolicy",
        child: 5,
        icon: <AnalyticsIcon />,
        subMenu: [],
      },
      {
        title: "Policy List",
        path: "/policyList",
        child: 5,
        icon: <AnalyticsIcon />,
        subMenu: [],
      },
      {
        title: "Online Policy",
        path: "/onlinePolicy",
        child: 5,
        icon: <AnalyticsIcon />,
        subMenu: [],
      },
      {
        title: "Brisk CPA/RSA",
        path: "/briskCreateCertificate",
        child: 5,
        icon: <AnalyticsIcon />,
        subMenu: [],
      },
      ...briskV2ListItem(5),
      ...roadzenCertItems(5),
    ],
  },
  {
    parent: 6,
    title: "Utilites",
    path: "/utilies",
    icon: (
      <img
        src={ManageAccountsIcon}
        alt="ManageAccountsIcon"
        style={{ width: "19px", height: "18px" }}
      />
    ),
    subMenu: [
      {
        title: "User Payable",
        path: "/userPayable",
        child: 6,
        icon: <AnalyticsIcon />,
        subMenu: [],
      },
      // {
      //   title: "Office Expenses",
      //   path: "/officeExpenses",
      //   child: 6,
      //   icon: <AnalyticsIcon />,
      //   subMenu: [],
      // }
    ],
  },
  {
    parent: 7,
    title: "Report",
    path: "/masterReport",
    icon: (
      <img
        src={SummarizeIcon}
        alt="SummarizeIcon"
        style={{ width: "19px", height: "18px" }}
      />
    ),
    subMenu: [],
  },
  // {
  //   parent: 8,
  //   title: "Renewal",
  //   path: "/renewalPolicy",
  //   icon: (
  //     <img
  //       src={EventRepeatIcon}
  //       alt="EventRepeatIcon"
  //       style={{ width: "17px", height: "19px" }}
  //     />
  //   ),
  //   subMenu: [],
  // },
  {
    parent: 9,
    title: "Wallet",
    path: "/wallet",
    icon: (
      <div className="menu-item">
        <img
          src={AccountBalanceWalletIcon}
          alt="AccountBalanceWalletIcon"
          style={{ width: "16px", height: "18px" }}
        />
        ,
      </div>
    ),
    subMenu: [
      {
        title: "User Wallet",
        path: "/userWallet",
        child: 9,
        icon: <AnalyticsIcon />,
        subMenu: [],
      },
      {
        title: "Motor Wallet",
        path: "/motorWallet",
        child: 9,
        icon: <AnalyticsIcon />,
        subMenu: [],
      },
      {
        title: "Branch Wallet",
        path: "/branchWallet",
        child: 9,
        icon: <AnalyticsIcon />,
        subMenu: [],
      },
      {
        title: "Brisk Wallet",
        path: "/briskWallet",
        child: 9,
        icon: <AnalyticsIcon />,
        subMenu: [],
      },
      // {
      //   title: "Brisk Transaction History",
      //   path: "/briskTransactionHistory",
      //   child: 9,
      //   icon: <AnalyticsIcon />,
      //   subMenu: [],
      // },
    ],
  },
  {
    parent: 10,
    title: "Motor Calculation",
    path: "/motorCalculation",
    icon: (
      <img
        src={MopedIcon}
        alt="MopedIcon"
        style={{ width: "15px", height: "18px" }}
      />
    ),
    subMenu: [],
  },
];

//Operator Menu
const OperatorMenu = [
  {
    parent: 1,
    title: "Dashboard",
    path: "/dashboard",
    icon: (
      <img
        src={DashboardIcon}
        alt="DashboardIcon"
        style={{ width: "19px", height: "18px" }}
      />
    ),
    subMenu: [],
  },
  {
    parent: 3,
    title: "User",
    path: "/user",
    icon: (
      <img
        src={AccountBoxIcon}
        alt="AccountBoxIcon"
        style={{ width: "15px", height: "18px" }}
      />
    ),
    subMenu: [],
  },
  {
    parent: 5,
    title: "Policy",
    path: "/policy",
    icon: (
      <img
        src={PolicyIcon}
        alt="PolicyIcon"
        style={{ width: "15px", height: "18px" }}
      />
    ),
    subMenu: [
      // {
      //   title: "Create Policy",
      //   path: "/policycreate",
      //   child: 5,
      //   icon: <AnalyticsIcon />,
      // },
      // {
      //   title: "Bulk Upload Policy",
      //   path: "/bulkUploadedPolicyList",
      //   child: 5,
      //   icon: <AnalyticsIcon />,
      //   subMenu: [],
      // },
      {
        title: "Online Policy",
        path: "/onlinePolicy",
        child: 5,
        icon: <AnalyticsIcon />,
        subMenu: [],
      },
      {
        title: "Search Policy",
        path: "/searchPolicy",
        child: 5,
        icon: <AnalyticsIcon />,
        subMenu: [],
      },
      {
        title: "Policy List",
        path: "/policyList",
        child: 5,
        icon: <AnalyticsIcon />,
        subMenu: [],
      },
      // {
      //   title: "CC Entry",
      //   path: "/ccentry",
      //   child: 5,
      //   icon: <AnalyticsIcon />,
      //   subMenu: [],
      // },
      {
        title: "Brisk CPA/RSA",
        path: "/briskCreateCertificate",
        child: 5,
        icon: <AnalyticsIcon />,
        subMenu: [],
      },
      ...briskV2ListItem(5),
      ...roadzenCertItems(5),
    ],
  },
  {
    parent: 6,
    title: "Utilites",
    path: "/utilies",
    icon: (
      <img
        src={ManageAccountsIcon}
        alt="ManageAccountsIcon"
        style={{ width: "19px", height: "18px" }}
      />
    ),
    subMenu: [
      {
        title: "Receivable Status",
        path: "/receivaleStatus",
        child: 6,
        icon: <AnalyticsIcon />,
        subMenu: [],
      },
      {
        title: "Cheque Status",
        path: "/chequeStatus",
        child: 6,
        icon: <AnalyticsIcon />,
        subMenu: [],
      },
      {
        title: "Log Status",
        path: "/logStatus",
        child: 6,
        icon: <AnalyticsIcon />,
        subMenu: [],
      },
    ],
  },
  {
    parent: 10,
    title: "Motor Calculation",
    path: "/motorCalculation",
    icon: (
      <img
        src={MopedIcon}
        alt="MopedIcon"
        style={{ width: "15px", height: "18px" }}
      />
    ),
    subMenu: [],
  },
];

//User Menu
const UserMenu = [
  {
    parent: 1,
    title: "Dashboard",
    path: "/dashboard",
    icon: (
      <img
        src={DashboardIcon}
        alt="DashboardIcon"
        style={{ width: "19px", height: "18px" }}
      />
    ),
    subMenu: [],
  },
  // Changes by Arun
  {
    parent: 5,
    title: "Policy",
    path: "/policy",
    icon: (
      <img
        src={PolicyIcon}
        alt="PolicyIcon"
        style={{ width: "15px", height: "18px" }}
      />
    ),
    subMenu: [
      // {
      //   title: "Create Policy",
      //   path: "/policycreate",
      //   child: 5,
      //   icon: <AnalyticsIcon />,
      // },
      {
        title: "Online Policy",
        path: "/onlinePolicy",
        child: 5,
        icon: <AnalyticsIcon />,
        subMenu: [],
      },
      {
        title: "Search Policy",
        path: "/searchPolicy",
        child: 5,
        icon: <AnalyticsIcon />,
        subMenu: [],
      },
      {
        title: "Policy List",
        path: "/policyList",
        child: 5,
        icon: <AnalyticsIcon />,
        subMenu: [],
      },
    ],
  },
  // Brisk and RoadZen certificates for a user login, each in its own navbar group (owner, 2026-11-03: "not in the same
  // navbar"): Create Certificate (his Policy Wallet pays too) and the list, with View + History only (the server's row
  // actions).
  ...(isBriskV2Enabled()
    ? [
        {
          parent: 12,
          title: "Brisk CPA/RSA",
          path: "/brisk",
          icon: <img src={PolicyIcon} alt="PolicyIcon" style={{ width: "15px", height: "18px" }} />,
          subMenu: [{ title: "Create Certificate", path: "/briskCreateCertificate", child: 12, icon: <AnalyticsIcon />, subMenu: [] }, ...briskV2ListItem(12)],
        },
      ]
    : []),
  // {
  //   parent: 13,
  //   title: "Zen CPA/RSA",
  //   path: "/roadzen",
  //   icon: <img src={PolicyIcon} alt="PolicyIcon" style={{ width: "15px", height: "18px" }} />,
  //   subMenu: [{ title: "Create Certificate", path: ROADZEN_CREATE_CERT_PATH, child: 13, icon: <AnalyticsIcon />, subMenu: [] }, roadzenListItem(13)],
  // },
  {
    parent: 6,
    title: "Utilites",
    path: "/utilies",
    icon: (
      <img
        src={ManageAccountsIcon}
        alt="ManageAccountsIcon"
        style={{ width: "19px", height: "18px" }}
      />
    ),
    subMenu: [
      {
        title: "Cheque Status",
        path: "/chequeStatus",
        child: 6,
        icon: <AnalyticsIcon />,
        subMenu: [],
      },
    ],
  },
  {
    parent: 7,
    title: "Report",
    path: "/masterReport",
    icon: (
      <img
        src={EventRepeatIcon}
        alt="EventRepeatIcon"
        style={{ width: "17px", height: "19px" }}
      />
    ),
    subMenu: [],
  },
  {
    parent: 9,
    title: "Wallet",
    path: "/wallet",
    icon: (
      <img
        src={AccountBalanceWalletIcon}
        alt="AccountBalanceWalletIcon"
        style={{ width: "16px", height: "18px" }}
      />
    ),
    subMenu: [
      {
        title: "User Wallet",
        path: "/userWallet",
        child: 9,
        icon: <AnalyticsIcon />,
        subMenu: [],
      },
      {
        title: "Policy Wallet",
        path: "/userPolicyWallet",
        child: 9,
        icon: <AnalyticsIcon />,
        subMenu: [],
      },
    ],
  },
  {
    parent: 10,
    title: "Motor Calculation",
    path: "/motorCalculation",
    icon: (
      <img
        src={MopedIcon}
        alt="MopedIcon"
        style={{ width: "15px", height: "18px" }}
      />
    ),
    subMenu: [],
  },
];

// Changed by Arun
//SubCode Menu
const SubCodeMenu = [
  {
    parent: 1,
    title: "Dashboard",
    path: "/dashboard",
    icon: (
      <img
        src={DashboardIcon}
        alt="DashboardIcon"
        style={{ width: "19px", height: "18px" }}
      />
    ),
    subMenu: [],
  },
  {
    // Master dropdown for non-admin roles. The page itself is role-aware:
    // these users see ONLY the make/models assigned to them and may edit only
    // their own discount — see MakeModel.js.
    parent: 20,
    title: "Master",
    path: "/master",
    icon: (
      <img
        src={ConfirmationNumberIcon}
        alt="ConfirmationNumberIcon"
        style={{ width: "19px", height: "18px" }}
      />
    ),
    subMenu: [
      {
        title: "Make and Model",
        path: "/makeModel",
        child: 20,
        icon: <AnalyticsIcon />,
        subMenu: [],
      },
      {
        // Same role split: assigned rows only, and anything added here is
        // linked to this user automatically — see RTOCityLocation.js.
        title: "RTO City Location",
        path: "/rtoCityLocation",
        child: 20,
        icon: <AnalyticsIcon />,
        subMenu: [],
      },
    ],
  },
  // Changes by Arun
  {
    parent: 4,
    title: "Company Login",
    path: "/companyLogin",
    icon: (
      <div className="menu-item">
        <img
          src={AddBusinessIcon}
          alt="AddBusinessIcon"
          style={{ width: "19px", height: "18px" }}
        />
      </div>
    ),
    subMenu: [],
  },
  {
    parent: 5,
    title: "Search Policy",
    path: "/searchPolicy",
    icon: (
      <img
        src={PolicyIcon}
        alt="PolicyIcon"
        style={{ width: "15px", height: "18px" }}
      />
    ),
  },
  {
    parent: 6,
    title: "CC Entry",
    path: "/ccentry",
    icon: (
      <img
        src={MopedIcon}
        alt="MopedIcon"
        style={{ width: "15px", height: "18px" }}
      />
    ),
    subMenu: [],
  },
  {
    parent: 7,
    title: "Comission Receivable",
    path: "/commisionReceivale",
    icon: <AnalyticsIcon />,
    subMenu: [],
  },
  {
    parent: 8,
    title: "Report",
    path: "/product",
    icon: (
      <img
        src={SummarizeIcon}
        alt="SummarizeIcon"
        style={{ width: "17px", height: "19px" }}
      />
    ),
    subMenu: [
      {
        title: "Master Report",
        path: "/masterReport",
        child: 8,
        icon: <AnalyticsIcon />,
        subMenu: [],
      },
      {
        title: "Booking Report",
        path: "/bookingReport",
        child: 8,
        icon: <AnalyticsIcon />,
        subMenu: [],
      },
    ],
  },
  // RoadZen certificates: every login creates (owner, 2026-11-03: "create page want to show for all users")
  // {
  //   parent: 13,
  //   title: "Zen CPA/RSA",
  //   path: "/roadzen",
  //   icon: (
  //     <img
  //       src={PolicyIcon}
  //       alt="PolicyIcon"
  //       style={{ width: "15px", height: "18px" }}
  //     />
  //   ),
  //   subMenu: roadzenCertItems(13),
  // },
];

//PT Staff Menu
const PTStaffMenu = [
  {
    parent: 1,
    title: "Dashboard",
    path: "/dashboard",
    icon: (
      <img
        src={DashboardIcon}
        alt="DashboardIcon"
        style={{ width: "19px", height: "18px" }}
      />
    ),
    subMenu: [],
  },
  {
    // Master dropdown for non-admin roles. The page itself is role-aware:
    // these users see ONLY the make/models assigned to them and may edit only
    // their own discount — see MakeModel.js.
    parent: 20,
    title: "Master",
    path: "/master",
    icon: (
      <img
        src={ConfirmationNumberIcon}
        alt="ConfirmationNumberIcon"
        style={{ width: "19px", height: "18px" }}
      />
    ),
    subMenu: [
      {
        title: "Make and Model",
        path: "/makeModel",
        child: 20,
        icon: <AnalyticsIcon />,
        subMenu: [],
      },
      {
        // Same role split: assigned rows only, and anything added here is
        // linked to this user automatically — see RTOCityLocation.js.
        title: "RTO City Location",
        path: "/rtoCityLocation",
        child: 20,
        icon: <AnalyticsIcon />,
        subMenu: [],
      },
    ],
  },
  {
    parent: 3,
    title: "Policy",
    path: "/policyList",
    icon: (
      <img
        src={AccountBoxIcon}
        alt="AccountBoxIcon"
        style={{ width: "15px", height: "18px" }}
      />
    ),
    subMenu: [],
  },
  {
    parent: 10,
    title: "CC Entry",
    path: "/ccentry",
    icon: (
      <img
        src={MopedIcon}
        alt="MopedIcon"
        style={{ width: "15px", height: "18px" }}
      />
    ),
    subMenu: [],
  },
  // RoadZen certificates: every login creates (owner, 2026-11-03: "create page want to show for all users")
  // {
  //   parent: 13,
  //   title: "Zen CPA/RSA",
  //   path: "/roadzen",
  //   icon: (
  //     <img
  //       src={PolicyIcon}
  //       alt="PolicyIcon"
  //       style={{ width: "15px", height: "18px" }}
  //     />
  //   ),
  //   subMenu: roadzenCertItems(13),
  // },
];

// Drops items flagged `clientOnly` for everyone except the CLIENT (owner)
// login, and items flagged `superAdminOnly` for everyone whose roleId is not
// SUPER_ADMIN; a dropdown left with no items is dropped too, so it cannot turn
// into a dead link.
const menuForUser = (menus, userType, roleId) => {
  const visible = (item) =>
    (!item.clientOnly || userType === "CLIENT") &&
    (!item.superAdminOnly || roleId === "SUPER_ADMIN");
  return menus.reduce((kept, menu) => {
    if (!visible(menu)) return kept;
    if (!menu.subMenu?.length) return [...kept, menu];
    const subMenu = menuForUser(menu.subMenu, userType, roleId);
    return subMenu.length ? [...kept, { ...menu, subMenu }] : kept;
  }, []);
};

export {
  menuForUser,
  AdminMenu,
  BranchManagerMenu,
  OperatorMenu,
  UserMenu,
  PTStaffMenu,
  SubCodeMenu,
};
